export default "__VITE_ASSET__DvxNee4C__"